
/*
 * ! @chakra-ui/vue v0.12.0 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { R as createStyledAttrsMixin } from './index-2557a15f.js';
import './chakra-ui-styled-system.esm-36097b89.js';
import { keyframes } from '@emotion/css';
import 'vue';
import './color-mode-observer-d3e4ca7f.js';
import CVisuallyHidden from './CVisuallyHidden.js';

var templateObject = Object.freeze(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]);
var spin = keyframes(templateObject);
var sizes = {
  xs: {
    w: '0.75rem',
    h: '0.75rem'
  },
  sm: {
    w: '1rem',
    h: '1rem'
  },
  md: {
    w: '1.5rem',
    h: '1.5rem'
  },
  lg: {
    w: '2rem',
    h: '2rem'
  },
  xl: {
    w: '3rem',
    h: '3rem'
  }
};

var createCustomSize = function createCustomSize(size) {
  return {
    w: size,
    h: size
  };
};

var setSizes = function setSizes(props) {
  return sizes[props.size] || createCustomSize(props.size);
};
/**
 * CSpinner component
 *
 * The spinner componenet
 *
 * @extends CPseudoBox
 * @see Docs https://vue.chakra-ui.com/spinner
 */


var CSpinner = {
  name: 'CSpinner',
  mixins: [createStyledAttrsMixin('CSpinner')],
  props: {
    size: {
      type: [String, Array],
      default: 'md'
    },
    label: {
      type: String,
      default: 'Loading...'
    },
    thickness: {
      type: [String, Array],
      default: '2px'
    },
    speed: {
      type: [String, Array],
      default: '0.45s'
    },
    color: {
      type: [String, Array],
      default: 'gray.200'
    },
    emptyColor: {
      type: [String, Array],
      default: 'transparent'
    }
  },
  computed: {
    componentStyles: function componentStyles() {
      return Object.assign({}, {
        d: 'inline-block',
        borderWidth: this.thickness,
        borderColor: 'currentColor',
        borderStyle: 'solid',
        rounded: 'full',
        color: this.color,
        borderBottomColor: this.emptyColor,
        borderLeftColor: this.emptyColor,
        animation: spin + " " + this.speed + " linear infinite"
      }, setSizes(this.$props));
    }
  },
  render: function render(h) {
    return h('div', {
      class: this.className,
      attrs: this.computedAttrs
    }, this.label && h(CVisuallyHidden, {}, this.label));
  }
};

export default CSpinner;
